import { render, staticRenderFns } from "./SubmitForSignoffButton.vue?vue&type=template&id=c6e75cf2&"
import script from "./SubmitForSignoffButton.vue?vue&type=script&lang=js&"
export * from "./SubmitForSignoffButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports